import { ArrowRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import styles from './PillarCard.module.css';

interface PillarCardProps {
  body: string;
  ctaHref: string;
  ctaLabel: string;
  icon: ReactNode;
  title: string;
}

export function PillarCard({
  body,
  ctaHref,
  ctaLabel,
  icon,
  title,
}: PillarCardProps) {
  return (
    <article className={styles.card}>
      <span aria-hidden="true" className={styles.iconWrap}>
        {icon}
      </span>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.copy}>{body}</p>
      </div>
      <Link className={styles.cta} to={ctaHref}>
        <span>{ctaLabel}</span>
        <ArrowRight aria-hidden="true" size={16} />
      </Link>
    </article>
  );
}
